// extracted by mini-css-extract-plugin
module.exports = {"cp-modal-ticket__preview":"styles_cp-modal-ticket__preview__3v_Mg","cp-modal-ticket__cert__preview":"styles_cp-modal-ticket__cert__preview__sRURJ","editor":"styles_editor__amDb2"};